module.exports = __webpack_public_path__ + "static/media/404logo2.41bd1265.svg";